const _ = require('lodash');

function StorePickerPanelService(ContentOverlayService, LocalStorageService, BreakpointsService) {
    this.isOpen = false;
    this.ContentOverlayService = ContentOverlayService;
    this.BreakpointsService = BreakpointsService;
    this.localStorageService = LocalStorageService;
    this.fullfillmentOptions = { disableFullfillmentOptions: true };
    this.changeStoreView = false;
    this.deliverySearch = {};
    this.getSuburbInLocalStorage();
    this.onPanelClosed = null;
    this.showStorePrompt = true;
}

StorePickerPanelService.prototype.open = function () {
    this.changeStoreView = false;

    this.ContentOverlayService.open(this.close.bind(this), 'store-picker-panel_overlay');

    this.isOpen = true;
};

StorePickerPanelService.prototype.setSuburbInLocalStorage = function (deliveryLocation) {
    this.deliverySearch = deliveryLocation;

    if (!_.isEmpty(this.deliverySearch)) {
        this.localStorageService.setItem('deliveryLocation', JSON.stringify(deliveryLocation));
    }

};

StorePickerPanelService.prototype.getSuburbInLocalStorage = function () {
    if (this.localStorageService.deliveryLocation) {
        this.deliverySearch = JSON.parse(this.localStorageService.getItem('deliveryLocation'));
    }
};

StorePickerPanelService.prototype.close = function () {
    this.ContentOverlayService.close();
    this.showStoreList = false;
    this.isOpen = false;

    if (this.onPanelClosed && typeof this.onPanelClosed === 'function') {
        this.onPanelClosed();
    }
};

StorePickerPanelService.prototype.toggle = function () {
    if (this.isOpen) {
        this.close();
    } else {
        this.open();
    }
};


StorePickerPanelService.prototype.canShowStorePickerPanelOnLoad = function () {
    return window.location.pathname.indexOf('/unsubscribe-edm') === -1;
};

module.exports = StorePickerPanelService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/storepicker/store-picker-panel-service.js
 **/